/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { ApiAddressSearch } from "../model"
/**
 * AddressResourceApi - axios parameter creator
 */
export const AddressResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Search an address in mainland France
     * @param {string} queryText
     * @param {number} [timeout]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAddress: async (
      queryText: string,
      timeout?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'queryText' is not null or undefined
      assertParamExists("searchAddress", "queryText", queryText)
      const localVarPath = `/addresses/adresse`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (queryText !== undefined) {
        localVarQueryParameter["queryText"] = queryText
      }

      if (timeout !== undefined) {
        localVarQueryParameter["timeout"] = timeout
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Search an address overseas
     * @param {string} queryText
     * @param {number} [timeout]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAddressOverseas: async (
      queryText: string,
      timeout?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'queryText' is not null or undefined
      assertParamExists("searchAddressOverseas", "queryText", queryText)
      const localVarPath = `/addresses/adresseOutremer`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (queryText !== undefined) {
        localVarQueryParameter["queryText"] = queryText
      }

      if (timeout !== undefined) {
        localVarQueryParameter["timeout"] = timeout
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Search a city given a label
     * @param {string} queryText
     * @param {number} [timeout]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchCity: async (
      queryText: string,
      timeout?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'queryText' is not null or undefined
      assertParamExists("searchCity", "queryText", queryText)
      const localVarPath = `/addresses/city`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (queryText !== undefined) {
        localVarQueryParameter["queryText"] = queryText
      }

      if (timeout !== undefined) {
        localVarQueryParameter["timeout"] = timeout
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AddressResourceApi - functional programming interface
 */
export const AddressResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AddressResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Search an address in mainland France
     * @param {string} queryText
     * @param {number} [timeout]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchAddress(
      queryText: string,
      timeout?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiAddressSearch>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchAddress(
        queryText,
        timeout,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AddressResourceApi.searchAddress"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Search an address overseas
     * @param {string} queryText
     * @param {number} [timeout]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchAddressOverseas(
      queryText: string,
      timeout?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiAddressSearch>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchAddressOverseas(
        queryText,
        timeout,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AddressResourceApi.searchAddressOverseas"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Search a city given a label
     * @param {string} queryText
     * @param {number} [timeout]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchCity(
      queryText: string,
      timeout?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiAddressSearch>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchCity(
        queryText,
        timeout,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AddressResourceApi.searchCity"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AddressResourceApi - factory interface
 */
export const AddressResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AddressResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Search an address in mainland France
     * @param {AddressResourceApiSearchAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAddress(
      requestParameters: AddressResourceApiSearchAddressRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ApiAddressSearch>> {
      return localVarFp
        .searchAddress(requestParameters.queryText, requestParameters.timeout, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Search an address overseas
     * @param {AddressResourceApiSearchAddressOverseasRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAddressOverseas(
      requestParameters: AddressResourceApiSearchAddressOverseasRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ApiAddressSearch>> {
      return localVarFp
        .searchAddressOverseas(requestParameters.queryText, requestParameters.timeout, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Search a city given a label
     * @param {AddressResourceApiSearchCityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchCity(
      requestParameters: AddressResourceApiSearchCityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ApiAddressSearch>> {
      return localVarFp
        .searchCity(requestParameters.queryText, requestParameters.timeout, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for searchAddress operation in AddressResourceApi.
 */
export interface AddressResourceApiSearchAddressRequest {
  readonly queryText: string

  readonly timeout?: number
}

/**
 * Request parameters for searchAddressOverseas operation in AddressResourceApi.
 */
export interface AddressResourceApiSearchAddressOverseasRequest {
  readonly queryText: string

  readonly timeout?: number
}

/**
 * Request parameters for searchCity operation in AddressResourceApi.
 */
export interface AddressResourceApiSearchCityRequest {
  readonly queryText: string

  readonly timeout?: number
}

/**
 * AddressResourceApi - object-oriented interface
 */
export class AddressResourceApi extends BaseAPI {
  /**
   *
   * @summary Search an address in mainland France
   * @param {AddressResourceApiSearchAddressRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public searchAddress(
    requestParameters: AddressResourceApiSearchAddressRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AddressResourceApiFp(this.configuration)
      .searchAddress(requestParameters.queryText, requestParameters.timeout, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Search an address overseas
   * @param {AddressResourceApiSearchAddressOverseasRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public searchAddressOverseas(
    requestParameters: AddressResourceApiSearchAddressOverseasRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AddressResourceApiFp(this.configuration)
      .searchAddressOverseas(requestParameters.queryText, requestParameters.timeout, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Search a city given a label
   * @param {AddressResourceApiSearchCityRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public searchCity(
    requestParameters: AddressResourceApiSearchCityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AddressResourceApiFp(this.configuration)
      .searchCity(requestParameters.queryText, requestParameters.timeout, options)
      .then(request => request(this.axios, this.basePath))
  }
}
